import {emailValidator} from '../../../utils';
import {getNextPartnerQuestion} from '../flowPartners/flowPartners';

export const informPartnerEmail = (inputValue) => emailValidator(inputValue);

export const setPartnerEmail = (
  ecState,
  partnerSel,
  partnerVd,
  partnerEmail,
  idQuestion,
  quizPartners,
  partnersTypeList
) => {
  let partners = ecState.partners.map((partner) => {
    if (partner.id === partnerSel.id) {
      return {
        ...partner,
        email: partnerVd.partnerEmail
      };
    }

    return partner;
  });

  let nextQuestion = getNextPartnerQuestion(
    idQuestion,
    quizPartners,
    partners,
    partnerSel,
    partnersTypeList
  );

  let messages = [
    {
      text: partnerEmail,
      type: 'response-sent'
    }
  ];

  messages.push(...nextQuestion.messages);

  return {
    messages,
    partners,
    partnerEmail,
    nextPartner: nextQuestion.partner,
    changePartner: nextQuestion.nextPartner,
    responseType: nextQuestion.responseTypeChange,
    partnersComplete: nextQuestion.partnersComplete,
    partnersTypeList: nextQuestion.partnersTypeList
  };
};
